import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/24/outline';
import { parse as parseflatted } from 'flatted';
import React from 'react';
import FlattedText from '../../flatted-text/FlattedText';
import IconTitleItem from '../../IconTitleItem/IconTitleItem';
import { getWalletProtocolName } from '../../../utils/Wallet.util';

interface Props {
  data: any;
}

const buildSending = (data: any) => {
  if (data.address && data.protocol) {
    return (
      <>
        <IconTitleItem
          icon={<ArrowRightCircleIcon />}
          title='Sending Protocol'
          subTitle={getWalletProtocolName(data.protocol)}
        />
        <div className='col-span-2'>
          <IconTitleItem
            icon={<ArrowRightCircleIcon />}
            title='Sending Address'
            subTitle={data.address}
          />
        </div>
      </>
    );
  }
};

const buildReceiving = (data: any) => {
  if (data.receivingAddress && data.receivingProtocol) {
    return (
      <>
        <IconTitleItem
          icon={<ArrowLeftCircleIcon />}
          title='Receiving Protocol'
          subTitle={getWalletProtocolName(data.receivingProtocol)}
        />
        <div className='col-span-2'>
          <IconTitleItem
            icon={<ArrowLeftCircleIcon />}
            title='Receiving Address'
            subTitle={data.receivingAddress}
          />
        </div>
      </>
    );
  }
};

const AnchainRequest = ({ data }: Props) => {
  const parsedData = parseflatted(data);

  if (
    (parsedData.address && parsedData.protocol) ||
    (parsedData.receivingAddress && parsedData.receivingProtocol)
  ) {
    return (
      <>
        <div className='grid gap-3 grid-cols-3'>
          {buildSending(parsedData)}
          {buildReceiving(parsedData)}
        </div>
      </>
    );
  }

  return <FlattedText flattedText={data} />;
};

export default AnchainRequest;
